const features = [
  {
    icon: 'ri-file-list-2-line',
    title: '下拉式阅读',
    desc: '独创下拉阅读模式，告别翻页割裂感，漫画内容一气呵成，沉浸式体验让追更更上瘾。',
  },
  {
    icon: 'ri-global-line',
    title: '海量资源库',
    desc: '汇聚国漫、日漫、韩漫等10万+漫画作品，涵盖热血、恋爱、悬疑、奇幻等全品类题材。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日同步更新',
    desc: '紧跟各大平台更新节奏，热门连载第一时间上线，追更党再也不用担心错过最新章节。',
  },
  {
    icon: 'ri-lock-unlock-line',
    title: '完全免费畅读',
    desc: '所有漫画内容均可免费阅读，无需注册登录，无需会员充值，点开即看，随时随地畅享。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">为什么选择爱漫画</h2>
          <p className="text-sm text-foreground-500">四大核心优势，打造极致阅读体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feat, idx) => (
            <div key={idx} className="bg-background-100 rounded-2xl p-6 text-center group hover:scale-[1.03] transition-transform cursor-pointer">
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}